import { OreButton, OreHeading, OreIconButton, OreStack, OreText, SvgRepeat } from "@edenredespana/oreneta"
import ErrorLogo from '@/Account/ui/assets/Warning.svg'
import { LoginTranslation } from "../accountTranslation"
import { Trans, useTranslation } from "react-i18next"
import { useLocation, useNavigate } from "react-router-dom"
import { navigationRoutes, openNavigationRoutes } from "@/Shared/ui/routers"
import { SignUpTranslation } from "@/AutoEnrollment/ui/autoEnrollmentTranslation"

export const PasswordRecoveryPasswordChangeError = (): JSX.Element => {
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const comesFromChangePasswordFlow = location.state?.fromChangePassword
    return (
        <>
            {comesFromChangePasswordFlow && (
                <div style={{ margin: '3rem 20% 0 20%' }}>
                    <OreStack
                        direction="column"
                        space="large"
                        placeContent="space-between"
                        placeItems="center">
                        <div>
                            <figure>
                                <img src={ErrorLogo} alt="" />
                            </figure>
                        </div>
                        <OreStack direction="column" space="medium">
                            <header className="width-max">
                                <OreHeading size="headline-lg" align="center">
                                    {t(LoginTranslation.register.errorPage.title)}
                                </OreHeading>
                            </header>
                            <OreStack>
                                <OreText size="text-md" tone="neutral-600" align="center">
                                    <Trans t={t}>
                                        {t(LoginTranslation.recovery.passwordChangeError.subtitle)}
                                    </Trans>
                                </OreText>
                            </OreStack>
                            <OreStack>
                                <OreText size="text-md" tone="neutral-600" align="center">
                                    <Trans t={t} components={
                                        [
                                            <a href={`mailto:${import.meta.env.VITE_CONTACT_EMAIL}?subject=${t(LoginTranslation.recovery.errorModal.mailtoSubject)}`} />
                                        ]
                                    }>
                                        {t(LoginTranslation.recovery.passwordChangeError.subtitle2, {
                                            CONTACT_PHONE: t(SignUpTranslation.otp.tel),
                                            CONTACT_EMAIL: import.meta.env.VITE_CONTACT_EMAIL,
                                        })}
                                    </Trans>
                                </OreText>
                            </OreStack>
                        </OreStack>
                        <OreStack
                            direction="column"
                            space="small"
                            placeContent="space-between"
                            placeItems="center">
                            <OreButton
                                as="button"
                                category="primary"
                                onClick={() => navigate(-1)}
                                size="large"
                                icon={<SvgRepeat />}
                                iconAlign="right"
                            >
                                {t(LoginTranslation.register.errorPage.button)}
                            </OreButton>
                        </OreStack>
                    </OreStack>
                </div>
            )}
        </>
    )
}